import { render, staticRenderFns } from "./Webphone.vue?vue&type=template&id=250fc32b&scoped=true"
import script from "./Webphone.vue?vue&type=script&lang=js"
export * from "./Webphone.vue?vue&type=script&lang=js"
import style0 from "./Webphone.vue?vue&type=style&index=0&id=250fc32b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250fc32b",
  null
  
)

export default component.exports